const BackendWebsocketEvents = {};
let vueInstance = null;

BackendWebsocketEvents.install = function (Vue) {
    const storeVM = new Vue({
        data() {
            return {
                refreshGuiList: null,
                refreshDocList: null,
                refreshCatList: null,
                refreshApiList: null,
                refreshExposedList: null,
                refreshProcessList: null,
                diagramChanged: null,
                diagramChangedAppPage: null,
                websocket: null,
                keepAlive: null
            };
        }
    });
    Vue.prototype.$backendWebsocketEvents = {
        /**
         *
         * @param {String} tenant
         * @param {String} appId
         */
        startWebsocket(id) {
            const self = this;
            const { host } = window.location;
            const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";
            const appId = id || vueInstance.$store.getters["apps/currentApp"].id || vueInstance.$store.getters["main/getCurrentApplicationId"];
            if (self.websocket) {
                self.websocket.close();
            }
            if (appId) {
                self.websocket = new WebSocket(`${protocol + host}/websocket/statemanagement/${appId}`);
            }
            const tm = setTimeout(() => {}, 5000);
            function pong() {
                clearTimeout(tm);
            }
            function ping() {
                self.websocket.send("__ping__");
            }

            self.websocket.onopen = function () {
                setInterval(ping, 30000);
            };
            self.websocket.onmessage = (msg) => {
                if (msg.data === "__pong__") {
                    pong();
                } else {
                    if (msg.data.includes("persist")) {
                        vueInstance.$store.getters["apps/currentApp"].publishStatus = "UNPUBLISHED_CHANGES";
                    }
                    if (msg.data.includes("interfaceBuilder")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshGuiList");
                        storeVM.refreshGuiList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("documentBuilder")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshDocList");
                        storeVM.refreshDocList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("class") || msg.data.includes("diagram_class")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshClassData", { data: msg.data, id: appId });
                    } else if (msg.data.includes("catalog")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshCatList", { data: msg.data, id: appId });
                        storeVM.refreshCatList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("api")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshApiList");
                        storeVM.refreshApiList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("exposed")) {
                        vueInstance.$emit("backendWebsocketEvents-refreshExposedList");
                        storeVM.refreshExposedList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("process") || msg.data.includes("application")) {
                        if (msg.data.includes("publish")) {
                            vueInstance.$emit("backendWebsocketEvents-publishedApp", { data: msg.data, id: appId });
                        }
                        vueInstance.$emit("backendWebsocketEvents-refreshProcessList");
                        storeVM.refreshProcessList = { data: msg.data, id: appId };
                    } else if (msg.data.includes("diagram")) {
                        if (vueInstance.$router.currentRoute.name === "diagrams" || vueInstance.$router.currentRoute.name === "process") {
                            storeVM.diagramChanged = { data: msg.data, id: appId };
                        } else {
                            storeVM.diagramChangedAppPage = { data: msg.data, id: appId };
                        }
                    } else if (msg.data.includes("closeTaskInterface")) {
                        vueInstance.$emit("closeTaskInterface");
                    }
                }
                if (msg.data.includes("GDM")) {
                    vueInstance.$emit("backendWebsocketEvents-refreshGDMList", { data: msg.data, id: appId });
                } else if (msg.data.includes("dataStore")) {
                    vueInstance.$emit("backendWebsocketEvents-refreshDataStoreList", { data: msg.data, id: appId });
                }
            };
            self.websocket.onclose = function () {
            };
            self.websocket.onerror = function () { // since there is an error, sockets will close so...
                self.websocket.onclose = function () {
                };
            };
        },

        init(mainVueInstance) {
            vueInstance = mainVueInstance;
            if (vueInstance.$store.getters["apps/currentApp"].id || vueInstance.$store.getters["main/getCurrentApplicationId"]) {
                this.startWebsocket();
            }
        },
        websocket: null,
        get state() {
            return storeVM.$data;
        }
    };
};

export default BackendWebsocketEvents;
